var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1103_9756)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3906 5.01562C23.6837 5.16955 23.9625 5.40985 24.2316 5.60499L25.9015 6.81526L31.6123 10.9423L31.6129 15.0188L28.6863 15.021V12.9855C27.8471 12.4132 26.9891 11.8659 26.1403 11.3076L26.1378 21.4803C26.9915 20.8428 27.8447 20.2018 28.6869 19.5496L28.6891 17.2948L31.6132 17.2955L31.612 21.2346C28.9024 23.4527 26.13 25.6036 23.3916 27.7864L23.3906 5.01562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.72834 5.50684L8.75861 5.56168L8.73787 5.62018L8.76156 5.60517L8.76146 13.3349L5.89719 13.335L5.89622 11.2979L3.19245 13.2052L3.19201 15.3025L8.76125 15.3005L8.76038 27.6331C6.796 26.5194 4.86289 25.3362 2.91751 24.1884L0.387404 22.6941L0.385666 19.3738L3.07665 19.3741L3.07538 20.6548L5.89712 22.3189L5.89771 18.0631H0.387498L0.384766 11.2979C3.14042 9.33445 5.94739 7.43432 8.72834 5.50684Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4097 0.294618C16.2838 0.187737 16.152 0.0758768 16.018 0L10.6221 4.40019L10.6241 28.8664C11.3191 29.2719 12.017 29.6731 12.715 30.0744C13.8213 30.7104 14.9278 31.3464 16.023 32L21.5268 28.6244L21.5262 19.3276L18.3087 17.0883L18.3093 15.9487C18.6547 15.7012 19.0013 15.4549 19.348 15.2086C20.0776 14.6903 20.8076 14.1717 21.5271 13.6406L21.5268 4.39149L17.5819 1.24038L16.5497 0.411356C16.504 0.374623 16.4573 0.334976 16.4097 0.294618ZM16.0144 3.85665C16.2123 3.95906 16.4122 4.14041 16.5999 4.31071L16.5999 4.31074L16.6 4.31076C16.6777 4.38131 16.7534 4.44995 16.8259 4.5103L18.6875 6.0557L18.6878 12.3123L15.753 14.3593L14.9842 14.8938L13.5338 14.8957C13.5222 12.966 13.5509 11.033 13.5795 9.10086C13.5946 8.08763 13.6096 7.07464 13.6188 6.06248C14.1494 5.55281 14.6955 5.05701 15.2411 4.56163C15.4996 4.32702 15.7579 4.0925 16.0144 3.85665ZM13.5343 18.1375L14.6983 18.1388C15.0098 18.3471 15.314 18.5708 15.6175 18.7939L15.6175 18.7939L15.6176 18.7939L15.6177 18.794C15.7601 18.8987 15.9024 19.0034 16.0453 19.1062L18.6874 21.0132L18.6877 26.794L17.6741 27.4312C17.3117 27.6735 16.9399 27.9045 16.5686 28.1352C16.3869 28.248 16.2054 28.3609 16.025 28.4749L13.5331 26.9262L13.5343 18.1375Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1103_9756"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.df7ad25c205dae7d7b9ac7447164409b.svg";
export { ForwardRef as ReactComponent };